import { FC } from 'react';
import { LandingTextBlockStoryblok } from 'storyblok-types';
import { Container } from 'atoms/Container';
import { Body, HeadLine } from 'atoms/Typography/Typography';
import { RichTextMarkdown } from 'pages/StoryBlok/RichText';
import { isValidDate } from 'modules/stroyblok/services';
import styles from './LandingTextBlock.module.css';

interface IBlok extends LandingTextBlockStoryblok {
  backgroundColor?: { color: string };
  textColor?: { color: string };
}

export const LandingTextBlock: FC<{ blok: IBlok }> = ({ blok }) => {
  const isDateValid = isValidDate(blok.startDate, blok.expirationDate);

  return !isDateValid ? null : (
    <Container
      className={styles.root}
      style={{
        backgroundColor: blok.backgroundColor?.color,
      }}
    >
      <div className={styles.contentWrapper}>
        <RichTextMarkdown
          text={blok.textContent}
          components={{
            h1: ({ children }) => (
              <HeadLine type="m" color="purple" tag="h1" className={styles.h1}>
                {children}
              </HeadLine>
            ),
            h2: ({ children }) => (
              <HeadLine type="m" color="purple" tag="h2" className={styles.h2}>
                {children}
              </HeadLine>
            ),
            h3: ({ children }) => (
              <HeadLine
                type="xs"
                color="purple"
                tag="h3"
                weight="bold"
                className={styles.h3}
              >
                {children}
              </HeadLine>
            ),
            p: ({ children }) => (
              <Body
                type="lg"
                weight="medium"
                className={styles.p}
                style={{ color: blok.textColor?.color }}
              >
                {children}
              </Body>
            ),
          }}
        />
      </div>
    </Container>
  );
};
